/* metadata_fr.js – localisation française (Canada) */
import React from "react";
import { TbCalendarTime } from "react-icons/tb";
import { FaMapMarkerAlt, FaMoneyBill, FaWifi } from "react-icons/fa";
import { FaWheelchair, FaRestroom, FaPowerOff } from "react-icons/fa6";
import { MdAirlineSeatReclineExtra } from "react-icons/md";
import { HamiltonData } from "./schedule";
import { HamiltonLocationsFR } from "./pickup-locations-fr";
/* -------- HAMILTON -------- */
const HamiltonMetaFR = {
    header: {
        title: "Service de navette aéroportuaire Hamilton vers/de Toronto Pearson",
        subtitle: "Service d’autobus quotidien, abordable et fiable, sans arrêt, pour les passagers d’Air Canada",
        description:
            "Vous cherchez une navette aéroportuaire fiable et abordable au départ de Hamilton… une solution pratique pour éviter de conduire ou de payer des frais de stationnement onéreux à YYZ.",
        book: false,
    },
    seo: {
        title: "Landline – Service de navette Hamilton vers/de Toronto Pearson",
        description: "",
    },
    titles: {
        schedule: "Horaire",
        fares: "Tarifs",
        amenities: "Commodités",
    },
};
/* -------- KITCHENER-WATERLOO -------- */
const WaterlooMetaFR = {
    header: {
        title: "Service de navette aéroportuaire Kitchener-Waterloo vers/de Toronto Pearson",
        subtitle: "Service d’autobus quotidien, abordable et fiable, sans arrêt, pour les passagers d’Air Canada",
        description:
            "Vous cherchez une navette aéroportuaire fiable et abordable au départ de Kitchener-Waterloo… une solution pratique pour éviter de conduire ou de payer des frais de stationnement onéreux à YYZ.",
        book: false,
    },
    seo: {
        title: "Landline – Service de navette Kitchener-Waterloo vers/de Toronto Pearson",
        description: "",
    },
    titles: {
        schedule: "Horaire",
        fares: "Tarifs",
        amenities: "Commodités",
    },
};
/* -------- TABLEAUX DE TARIFS -------- */
const HamiltonFaresFR = {
    titles: [
        "Lieu",
        "Adultes",
        <p>Enfant<br /><small>(12 ans et moins)</small></p>,
        "Vacances Air Canada",
    ],
    data: [["Aéroport international de Hamilton (YHM)", "$49 CAD", "GRATUIT", "$40 CAD"]],
};
const WaterlooFaresFR = {
    titles: [
        "Lieu",
        "Adultes",
        <p>Enfant<br /><small>(12 ans et moins)</small></p>,
        "Vacances Air Canada",
    ],
    data: [
        ["Aéroport international de la région de Waterloo (YKF)", "$49 CAD", "GRATUIT", "$40 CAD"],
    ],
};
/* -------- MENU DE NAVIGATION -------- */
const NavigationItemsFR = [
    {
        icon: <FaMapMarkerAlt />,
        title: "Points d’embarquement",
        scrollTo: "pickup-locations",
    },
    {
        icon: <TbCalendarTime />,
        title: "Points de débarquement",
        scrollTo: "pickup-locations",
    },
    {
        icon: <FaMoneyBill />,
        title: "Tarifs",
        scrollTo: "fares",
    },
    {
        icon: <FaWifi />,
        title: "Commodités",
        scrollTo: "amenities",
    },
];
/* -------- COMMODITÉS -------- */
const AmenitiesListFR = [
    {
        icon: <FaWifi />,
        title: <p>Wi-Fi et divertissement<br />gratuits</p>,
    },
    {
        icon: <MdAirlineSeatReclineExtra />,
        title: "Sièges en cuir inclinables",
    },
    {
        icon: <FaPowerOff />,
        title: "Prises électriques à chaque siège",
    },
    {
        icon: <FaRestroom />,
        title: "Toilettes à bord",
    },
    {
        icon: <FaWheelchair />,
        title: "Accessibilité pour personnes handicapées",
    },
];
/* -------- PROMO VACANCES AIR CANADA -------- */
const TravelingDataFR = {
    title: "Vous voyagez avec Vacances Air Canada ?",
    subtitle: "20 % de rabais",
    text: (
        <>
            <p>
                Réservez directement avec Landline et économisez 20 % sur votre navette aéroportuaire
                vers/de Toronto Pearson (YYZ) en tant que passager Vacances Air Canada.
            </p>
            <p>
                Textez ou appelez notre équipe au{" "}
                <a href="tel:+12494920941">+1 (249) 492-0941</a> pour obtenir votre code de réduction
                exclusif dès maintenant.
            </p>
        </>
    ),
};

const French = {
  meta: HamiltonMetaFR,
  data: HamiltonData,
  fares: HamiltonFaresFR,
  navigation: NavigationItemsFR,
  traveling: TravelingDataFR,
  amenities: AmenitiesListFR,
  locations: HamiltonLocationsFR,
  english: false,
  french: true,
}

export {
    HamiltonMetaFR,
    WaterlooMetaFR,
    HamiltonFaresFR,
    WaterlooFaresFR,
    NavigationItemsFR,
    TravelingDataFR,
    AmenitiesListFR,
    French
};